import React from "react";
import { Navbar, Container, Button } from "react-bootstrap";
import { FaBars } from "react-icons/fa";
import "./navBar.css";

const NavBar = ({ title, onToggleSidebar }) => {
  return (
    <Navbar className="py-2" sticky="top">
      <Container fluid className="d-flex align-items-center justify-content-between">

        {/* Mobile Sidebar Toggle */}
        <Button
          variant="link"
          className="d-md-none text-dark p-0 me-3"
          onClick={onToggleSidebar}
        >
          <FaBars size={24} />
        </Button>

        {/* Page Title (Optional or inferred) */}
        <div className="d-flex align-items-center">
          {title && <h5 className="m-0 fw-bold text-dark">{title}</h5>}
        </div>

        {/* Right side placeholder - maybe notifications later */}
        <div className="d-flex align-items-center gap-3">
          {/* Use this space for a small logo if needed on mobile, or notifications */}
        </div>
      </Container>
    </Navbar>
  );
};

export default NavBar;
